import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const GetLiterals = createAction('[Shared: Literals]: Get Literals');

export const GetLiteralsSuccess = createAction('[Shared: Literals]: Get Literals Success', props<{ literals: any }>());

export const GetLiteralsFailed = createAction(
  '[Shared: Literals]: Get Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetSelectedLanguage = createAction('[Shared: Literals]: Get Selected Language');

export const GetSelectedLanguageSuccess = createAction(
  '[Shared: Literals]: Get Selected Language Success',
  props<{ selectedLanguage: string }>(),
);

export const GetSelectedLanguageFailed = createAction(
  '[Shared: Literals]: Get Selected Language Failed',
  props<{ error: HttpErrorResponse }>(),
);
